import {
  Warehouse,
  Snowflake,
  ThermometerSnowflake,
  Wind,
  Fan,
  Wrench,
  ShieldCheck,
  Ruler,
  Tag,
  Users,
  Zap,
  ClipboardCheck,
  BadgeCheck,
  Headset,
} from "lucide-react";

export const ICONS = {
  warehouse: Warehouse,
  snowflake: Snowflake,
  thermometer: ThermometerSnowflake,
  wind: Wind,
  fan: Fan,
  wrench: Wrench,
  shield: ShieldCheck,
  ruler: Ruler,
  tag: Tag,
  users: Users,
  zap: Zap,
  clipboard: ClipboardCheck,
  badge: BadgeCheck,
  headset: Headset,
};

export const ICON_OPTIONS = Object.keys(ICONS);

export function DynIcon({ name, className = "w-6 h-6" }) {
  const Cmp = ICONS[name] || Snowflake;
  return <Cmp className={className} />;
}
